/* eslint-disable max-lines */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { cancelSearch } from "api/search.api";

// import { cancelSearch, getRecentSearchList } from "api/search.api";
import { AnyNsRecord } from "dns";
import _, { findIndex } from "lodash";

export interface SearchSlice {
  selectedProject:
    | {
        id: number;
        title: string;
        name?: string;
      }
    | null
    | any;
  selectedProjectFromSearch: {
    id: number;
    title: string;
    name?: string;
  } | null;
  search_status: string;
  isCancelling: boolean;
  ever_worked: boolean;
  searchingLoading: boolean;
  run_sinecure_search: boolean;
  run_doximity: boolean | undefined;
  search_question_set_id: number | null;
  active_step: number;
  search_log: any;
  search_log_loading: number;
  active_search_role_id: any;
  search_name: any;
  reset_chat: boolean;
  is_freelance_search: boolean;
  job_titles: any;
  titles: any;
  locations: any;
  skills: any;
  universities: any;
  min_exp: number;
  max_exp: number;
  industries: any;
  full_name: null | string;
  isNamedSearch: boolean;

  work_experiences: any;
  industry_leaders: any;
  search_questions: string[];
  segments: any;
  company: any;
  exclude_company: any;
  processing_search_id: any;
  agency_parents: any;
  agency_types: any;
  agencies: any;
  worked_previously_at_companies: boolean;
  industry_type: any;
  school_groups: any;
  education_fields: any;
  education_levels: any;
  exclude_locations: any;
  active_search_role_name: string | null;
  include_subsidiaries: boolean;
  is_extension_search: boolean;
  tied_to_role: boolean;
  keywords: any;
  allow_previous_job_titles: boolean;
  exclude_subsidiaries: boolean;
  exclude_years: number;
  location_radius: number;
  exact_job_title_match: boolean;
  exact_keywords_match: boolean;
  must_have_keywords: boolean;
  include_ai_suggetions: boolean;
  search_only_greenhouse_mckinney: boolean;
  search_only_lever_ss: boolean;
}

const initialState: SearchSlice = {
  selectedProject: null,
  selectedProjectFromSearch: null,
  search_status: "end",
  active_step: 0,
  ever_worked: false,
  search_question_set_id: null,
  run_sinecure_search: true,
  run_doximity: undefined,
  search_log: [],
  search_log_loading: 1,
  active_search_role_id: null,
  search_name: "",
  reset_chat: false,
  is_freelance_search: false,
  isCancelling: false,
  searchingLoading: false,
  job_titles: [],
  titles: [],
  locations: [],
  exclude_locations: [],
  skills: [],
  universities: [],
  min_exp: 1,
  max_exp: 60,
  industries: [],
  full_name: null,
  isNamedSearch: false,
  work_experiences: [],
  industry_leaders: [],
  search_questions: [],
  segments: [],
  company: [],
  exclude_company: [],
  agency_parents: [],
  agency_types: [],
  agencies: [],
  worked_previously_at_companies: false,
  include_subsidiaries: false,
  is_extension_search: false,
  active_search_role_name: null,
  keywords: [],
  processing_search_id: null,
  industry_type: [],
  school_groups: [],
  education_fields: [],
  education_levels: [],
  tied_to_role: false,
  allow_previous_job_titles: false,
  exclude_subsidiaries: false,
  exclude_years: 0,
  location_radius: 0,
  exact_job_title_match: false,
  exact_keywords_match: false,
  must_have_keywords: false,
  include_ai_suggetions: false,
  search_only_greenhouse_mckinney: false,
  search_only_lever_ss: false,
};

export const doAddCandidateToRole = createAsyncThunk(
  "search/doAddCandidateToRole",
  async (payload: any, { dispatch }) => null
  // addCandidateToRole(payload).then((res: any) => {
  //   return res;
  // })
);
export const doGetSearchResultList = createAsyncThunk(
  "search/doGetSearchResultList",
  async (payload: any, { dispatch }) => null
  // getRecentSearchList().then((res: any) => {
  //   return res;
  // })
);
export const doSetResentSearchData = createAsyncThunk(
  "search/doSetResentSearchData",
  async (payload: any, { dispatch }) => null
  // getRecentSearchList().then((res: any) => {
  //   return res;
  // })
);

export const doCancelSearch = createAsyncThunk(
  "search/doCancelSearch",
  async (payload: any, { dispatch }) =>
    cancelSearch(payload).then((res) => {
      return res;
    })
);

export const addIndustryTypeAsync = createAsyncThunk(
  "search/addIndustryType",
  async (industry: any, { dispatch }) => {
    // Simulating an API delay (remove if unnecessary)
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Return industry to be added (can modify as needed)
    return industry;
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    clearSelectedProject: (state) => {
      state.selectedProject = null;
    },

    clearAllSkills: (state) => {
      state.skills = [];
    },
    clearAllJobTitle: (state) => {
      state.job_titles = [];
    },
    clearAllIndustry: (state) => {
      state.industries = [];
    },
    clearFullName: (state) => {
      state.full_name = null;
    },
    clearAllCompanies: (state) => {
      state.company = [];
    },
    clearAllExcludeCompanies: (state) => {
      state.exclude_company = [];
    },
    clearAllLocation: (state) => {
      state.locations = [];
    },
    clearAllExcludeLocation: (state) => {
      state.exclude_locations = [];
    },
    clearAllWorkExperiences: (state) => {
      state.work_experiences = [];
    },
    clearAllIndustryLeader: (state) => {
      state.industry_leaders = [];
    },
    clearSearchQuestions: (state) => {
      state.search_questions = [];
    },
    clearAllIndustrySegment: (state) => {
      state.segments = [];
    },
    clearAllUniversities: (state) => {
      state.universities = [];
    },
    clearAllFields: (state) => {
      state.education_fields = [];
    },
    clearAllEducationLevel: (state) => {
      state.education_levels = [];
    },
    setSearchStatus: (state, action: PayloadAction<any>) => {
      state.search_status = action.payload;
    },
    setSelectedProjectFromSearch: (state, action: PayloadAction<any>) => {
      state.selectedProjectFromSearch = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<any>) => {
      state.active_step = action.payload;
    },
    setEverWorked: (state, action: PayloadAction<any>) => {
      state.ever_worked = action.payload === true;
    },
    setSearchQuestionSetId: (state, action: PayloadAction<any>) => {
      state.search_question_set_id = action.payload;
    },
    setSearchLoading: (state, action: PayloadAction<any>) => {
      state.searchingLoading = action.payload;
    },
    setIsDoximity: (state, action: PayloadAction<any>) => {
      state.run_doximity = action.payload;
    },
    setIsSinecure: (state, action: PayloadAction<any>) => {
      state.run_sinecure_search = action.payload;
    },
    addName: (state, action: PayloadAction<any>) => {
      state.search_name = action.payload;
    },
    changeResetChat: (state) => {
      state.reset_chat = !state.reset_chat;
    },
    changeIsFreelance: (state, action: PayloadAction<any>) => {
      state.is_freelance_search = action.payload;
    },
    changeIsNamedSearch: (state, action: PayloadAction<any>) => {
      state.isNamedSearch = action.payload;
    },
    removeName: (state, action: PayloadAction<any>) => {
      state.search_name = "";
    },

    addJobTitle: (state, action: PayloadAction<string | string[]>) => {
      const jobTitles = Array.isArray(action.payload) ? action.payload : [action.payload];

      jobTitles.forEach((jobTitle) => {
        if (state.job_titles.includes(jobTitle)) {
          state.job_titles = state.job_titles.filter((j: string) => j !== jobTitle);
          state.job_titles.push(jobTitle);
        } else {
          state.job_titles.push(jobTitle);
        }
      });
    },

    addSalesJobTitle: (state, action: PayloadAction<any>) => {
      const jonTitles = state.job_titles.filter((jobTitle: any) => jobTitle !== action.payload);
      state.job_titles = [...jonTitles, ...action.payload];
    },
    removeJobTitle: (state, action: PayloadAction<any>) => {
      state.job_titles = state.job_titles.filter((keyword: string) => keyword !== action.payload);
    },
    removeAllJobTitle: (state, action: PayloadAction<any>) => {
      state.job_titles = [];
    },
    addModelCandidate: (state, action: PayloadAction<any>) => {
      state.job_titles = [];
    },
    removeLocation: (state, action: PayloadAction<any>) => {
      state.locations = state.locations.filter((location: string) => location !== action.payload);
    },
    updateLocationRadius: (state, action: PayloadAction<any>) => {
      state.location_radius = action.payload;
    },
    addLocation: (state, action: PayloadAction<any>) => {
      const data = Array.isArray(action.payload) ? [...action.payload] : [action.payload];
      state.locations = [...state.locations, ...data];
    },
    removeExcludeLocation: (state, action: PayloadAction<any>) => {
      const { city } = action.payload;
      state.exclude_locations = state.exclude_locations.filter((l: any) => l.city !== city);
    },
    addExcludeLocation: (state, action: PayloadAction<any>) => {
      const data = Array.isArray(action.payload) ? [...action.payload] : [action.payload];
      state.exclude_locations = [...state.exclude_locations, ...data];
    },
    addExcludeLocations: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        state.exclude_locations = [...state.exclude_locations, ...action.payload];
      }
    },
    resetExcludeLocations: (state) => {
      state.exclude_locations = [];
    },

    addLocations: (state, action: PayloadAction<any>) => {
      const locs = state.locations.filter((l: any) => action.payload.indexOf(l) === -1);
      state.locations = [...locs, ...action.payload];
    },
    resetLocations: (state) => {
      state.locations = [];
    },

    addSingleLocations: (state, action: PayloadAction<any>) => {
      state.locations = [action.payload];
    },

    addSkill: (state, action: PayloadAction<any>) => {
      const skill = action.payload;
      if (state.skills.includes(skill)) {
        state.skills = state.skills.filter((k: string) => k !== skill);
      } else {
        state.skills.push(skill);
      }
    },
    addSkills: (state, action: PayloadAction<string[]>) => {
      const newSkills = action.payload;
      newSkills.forEach((skill) => {
        if (state.skills.includes(skill)) {
          state.skills = state.skills.filter((k: string) => k !== skill);
        } else {
          state.skills.push(skill);
        }
      });
    },

    removeSkill: (state, action: PayloadAction<any>) => {
      state.skills = state.skills.filter((keyword: string) => keyword !== action.payload);
    },

    resetSkill: (state) => {
      state.skills = [];
    },
    addFullName: (state, action: PayloadAction<string>) => {
      state.full_name = action.payload;
    },

    addUniversity: (state, action: PayloadAction<string | string[]>) => {
      const universities = Array.isArray(action.payload) ? action.payload : [action.payload];

      universities.forEach((university) => {
        if (state.universities.includes(university)) {
          state.universities = state.universities.filter((uni: string) => uni !== university);
        } else {
          state.universities.push(university);
        }
      });
    },

    removeUniversity: (state, action: PayloadAction<any>) => {
      state.universities = state.universities.filter((uni: any) => uni !== action.payload);
    },

    addMinExp: (state, action: PayloadAction<any>) => {
      state.min_exp = action.payload;
    },
    addMaxExp: (state, action: PayloadAction<any>) => {
      state.max_exp = action.payload;
    },
    removeMinMaxExp: (state, action: PayloadAction<any>) => {
      state.min_exp = 1;
      state.max_exp = 60;
    },

    addIndustry: (state, action: PayloadAction<string | string[]>) => {
      const industries = Array.isArray(action.payload) ? action.payload : [action.payload];

      industries.forEach((industry) => {
        if (state.industries.includes(industry)) {
          state.industries = state.industries.filter((k: string) => k !== industry);
        } else {
          state.industries.push(industry);
        }
      });
    },

    removeIndustry: (state, action: PayloadAction<any>) => {
      state.industries = state.industries.filter((keyword: string) => keyword !== action.payload);
    },
    addIndustryType: (state, action: PayloadAction<any>) => {
      const industry = action.payload;
      if (state.industry_type.includes(industry)) {
        state.industry_type = state.industry_type.filter((k: string) => k !== industry);
      } else {
        state.industry_type.push(industry);
      }
    },
    removeIndustryType: (state, action: PayloadAction<any>) => {
      state.industry_type = state.industry_type.filter(
        (keyword: string) => keyword !== action.payload
      );
    },
    addSchoolGroup: (state, action: PayloadAction<any>) => {
      const industries = state.school_groups.filter((ind: any) => ind !== action.payload);

      state.school_groups = [...industries, action.payload];
    },
    removeSchoolGroup: (state, action: PayloadAction<any>) => {
      state.school_groups = state.school_groups.filter((uni: any) => uni !== action.payload);
    },
    addEducationLevels: (state, action: PayloadAction<any>) => {
      const industries = state.education_levels.filter((ind: any) => ind !== action.payload);

      state.education_levels = [...industries, action.payload];
    },
    removeEducationLevels: (state, action: PayloadAction<any>) => {
      state.education_levels = state.education_levels.filter((uni: any) => uni !== action.payload);
    },
    addEducationFields: (state, action: PayloadAction<string | string[]>) => {
      const fields = Array.isArray(action.payload) ? action.payload : [action.payload];
      fields.forEach((field) => {
        if (state.education_fields.includes(field)) {
          state.education_fields = state.education_fields.filter((ind: string) => ind !== field);
        } else {
          state.education_fields.push(field);
        }
      });
    },

    removeEducationFields: (state, action: PayloadAction<any>) => {
      state.education_fields = state.education_fields.filter((uni: any) => uni !== action.payload);
    },

    removeWorkExperience: (state, action: PayloadAction<any>) => {
      state.work_experiences = state.work_experiences.filter((exp: any) => exp !== action.payload);
    },

    addIndustryLeader: (state, action: PayloadAction<any>) => {
      const indLeaders = state.industry_leaders.filter((ind: any) => ind !== action.payload);

      state.industry_leaders = [...indLeaders, action.payload];
    },
    removeIndustryLeader: (state, action: PayloadAction<any>) => {
      state.industry_leaders = state.industry_leaders.filter((uni: any) => uni !== action.payload);
    },
    addSearchQuestions: (state, action: PayloadAction<any>) => {
      const search_questions = state.search_questions;

      state.search_questions = [...search_questions, action.payload];
    },
    setSearchQuestions: (state, action: PayloadAction<any>) => {
      state.search_questions = action.payload;
    },
    removeSearchQuestions: (state, action: PayloadAction<any>) => {
      state.search_questions = state.search_questions.filter((uni: any) => uni !== action.payload);
    },
    addAllIndustrysegment: (state, action: PayloadAction<any>) => {
      const segment = action.payload;
      state.segments = [...segment];
    },
    addIndustrysegment: (state, action: PayloadAction<any>) => {
      const segment = action.payload;
      if (state.segments.includes(segment)) {
        state.segments = state.segments.filter((s: string) => s !== segment);
      } else {
        state.segments.push(segment);
      }
    },

    addKeyword: (state, action: PayloadAction<string | string[]>) => {
      const keywords = Array.isArray(action.payload) ? action.payload : [action.payload];

      keywords.forEach((keyword) => {
        state.keywords = state.keywords.filter((ind: string) => ind !== keyword);
        state.keywords.push(keyword);
      });
    },

    removeKeyword: (state, action: PayloadAction<any>) => {
      state.keywords = state.keywords.filter((keyword: string) => keyword !== action.payload);
    },
    resetKeyword: (state) => {
      state.keywords = [];
    },
    addCandidateWorkCompany: (state, action: PayloadAction<any>) => {
      const indLeaders = state.company.filter((ind: any) => ind.name !== action.payload);

      state.company = [...indLeaders, { name: action.payload }];
    },
    addCandidateWorkCompanyList: (state, action: PayloadAction<any>) => {
      state.company = _.uniqBy([...state.company, ...action.payload], "name");
    },
    resetCandidateWorkCompanyList: (state) => {
      state.company = [];
    },
    removeCandidateWorkCompany: (state, action: PayloadAction<any>) => {
      state.company = state.company.filter((uni: any) =>
        typeof uni === "string" ? uni !== action.payload : uni.name !== action.payload
      );
    },
    addStartYear: (state, action: PayloadAction<any>) => {
      const companyList = [...state.company];
      const index = findIndex(companyList, "name", action.payload.name);

      if (typeof companyList[index] === "string") {
        companyList[index] = {};
        companyList[index].name = action.payload.name;
        companyList[index].year_from = action.payload.year_from;
        companyList[index].year_to = "";
      } else {
        companyList[index].year_from = action.payload.year_from;
      }

      state.company = [...companyList];
    },
    addEndYear: (state, action: PayloadAction<any>) => {
      const companyList = [...state.company];
      const index = findIndex(companyList, "name", action.payload.name);
      if (typeof companyList[index] === "string") {
        companyList[index] = {};
        companyList[index].name = action.payload.name;
        companyList[index].year_to = action.payload.year_to;
        companyList[index].year_from = "";
      } else {
        companyList[index].year_to = action.payload.year_to;
      }

      state.company = [...companyList];
    },
    addExcludeCompany: (state, action: PayloadAction<any>) => {
      const indLeaders = state.exclude_company.filter((ind: any) => ind !== action.payload);

      state.exclude_company = [...indLeaders, action.payload];
    },
    addCandidateExcludeCompanyList: (state, action: PayloadAction<any>) => {
      state.exclude_company = _.uniq([...state.exclude_company, ...action.payload]);
    },
    removeExcludeCompany: (state, action: PayloadAction<any>) => {
      state.exclude_company = state.exclude_company.filter((uni: any) => uni !== action.payload);
    },
    resetExcludeCompany: (state) => {
      state.exclude_company = [];
    },

    setRoleId: (state, action: PayloadAction<any>) => {
      state.active_search_role_id = parseInt(action.payload);
    },
    setRoleName: (state, action: PayloadAction<any>) => {
      state.active_search_role_name = action.payload;
    },
    resetRoleId: (state, action: PayloadAction<any>) => {
      state.active_search_role_id = null;
    },
    resetRoleName: (state, action: PayloadAction<any>) => {
      state.active_search_role_name = null;
    },
    setProcessingSearchId: (state, action: PayloadAction<any>) => {
      state.processing_search_id = action.payload;
    },
    removeProcessingSearchId: (state, action: PayloadAction<any>) => {
      state.processing_search_id = null;
    },
    setAgencyParent: (state, action: PayloadAction<any>) => {
      const parent = state.agency_parents
        ? state.agency_parents.filter((ind: any) => ind !== action.payload)
        : [];

      state.agency_parents = [...parent, action.payload];
    },
    removeAgencyParent: (state, action: PayloadAction<any>) => {
      state.agency_parents = state.agency_parents.filter((uni: any) => uni !== action.payload);
    },
    resetAgencyParent: (state) => {
      state.agency_parents = [];
    },
    setAgencyType: (state, action: PayloadAction<any>) => {
      const parent = state.agency_types.filter((ind: any) => ind !== action.payload);

      state.agency_types = [...parent, action.payload];
    },
    setMultipleAgencyType: (state, action: PayloadAction<any>) => {
      state.agency_types = [...action.payload];
    },
    removeAgencyType: (state, action: PayloadAction<any>) => {
      state.agency_types = state.agency_types.filter((uni: any) => uni !== action.payload);
    },
    resetAgencyType: (state) => {
      state.agency_types = [];
    },
    setAgencies: (state, action: PayloadAction<any>) => {
      const parent = state.agencies.filter((ind: any) => ind !== action.payload);
      state.agencies = [...parent, action.payload];
    },
    setMultipleAgency: (state, action: PayloadAction<any>) => {
      state.agencies = [...action.payload];
    },
    removeAgencies: (state, action: PayloadAction<any>) => {
      state.agencies = state.agencies.filter((uni: any) => uni !== action.payload);
    },
    resetAgencies: (state) => {
      state.agencies = [];
    },
    setExactJobTitleMatch: (state, action: PayloadAction<any>) => {
      state.exact_job_title_match = action.payload;
    },
    resetExactJobTitleMatch: (state, action: PayloadAction<any>) => {
      state.exact_job_title_match = false;
    },
    setExactkeywordsMatch: (state, action: PayloadAction<any>) => {
      state.exact_keywords_match = action.payload;
    },
    resetExactkeywordsMatch: (state, action: PayloadAction<any>) => {
      state.exact_keywords_match = false;
    },
    setMustHavekeywords: (state, action: PayloadAction<any>) => {
      state.must_have_keywords = action.payload;
    },
    resetMustHavekeywords: (state, action: PayloadAction<any>) => {
      state.must_have_keywords = false;
    },
    setIncludeAISuggetions: (state, action: PayloadAction<any>) => {
      state.include_ai_suggetions = action.payload;
    },
    resetIncludeAISuggetions: (state, action: PayloadAction<any>) => {
      state.include_ai_suggetions = false;
    },
    setOnlyGreenHouseCandidate: (state, action: PayloadAction<any>) => {
      state.search_only_greenhouse_mckinney = action.payload;
    },
    resetOnlyGreenHouseCandidate: (state, action: PayloadAction<any>) => {
      state.search_only_greenhouse_mckinney = false;
    },
    setOnlyLeverCandidate: (state, action: PayloadAction<any>) => {
      state.search_only_lever_ss = action.payload;
    },
    resetOnlyLeverCandidate: (state, action: PayloadAction<any>) => {
      state.search_only_lever_ss = false;
    },
    setModelCandidate: (state, action: PayloadAction<any>) => {
      state.job_titles = [...action.payload.job_titles];

      state.locations = [...action.payload.locations];
      state.skills = [...action.payload.skills];
      state.universities = [...action.payload.universities];

      state.industries = [...action.payload.industries];
      state.industry_leaders = [...action.payload.industry_leaders];
      state.segments = [...action.payload.segments];
      state.company = [...action.payload.candidate_works];
    },

    setWorkOnPreviousCompany: (state, action: PayloadAction<any>) => {
      state.worked_previously_at_companies = action.payload;
    },
    setTitleWithPreviousJob: (state, action: PayloadAction<any>) => {
      state.allow_previous_job_titles = action.payload;
    },

    setIncludeSubsidiaries: (state, action: PayloadAction<any>) => {
      state.include_subsidiaries = action.payload;
    },
    setExtensionSearch: (state, action: PayloadAction<any>) => {
      state.is_extension_search = action.payload;
    },
    setExcludeSubsidiaries: (state, action: PayloadAction<any>) => {
      state.exclude_subsidiaries = action.payload;
    },

    setExcludeYears: (state, action: PayloadAction<any>) => {
      state.exclude_years = action.payload ? action.payload : 0;
    },

    setTieToRole: (state, action: PayloadAction<any>) => {
      state.tied_to_role = action.payload;
    },
    setSearch: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      const {
        active_search_role_id = null,
        search_name = "",
        job_title = [],
        titles = [],
        locations = [],
        skills = [],
        universities = [],
        min_exp = 1,
        max_exp = 60,
        industries = [],
        work_experiences = [],
        industry_leaders = [],
        search_questions = [],
        segments = [],
        candidate_works = [],
        company = [],
        exclude_company = [],
        agencies = [],
        agencyParent = [],
        agencyType = [],
        companyGroups = [],
        exclude_locations = [],
        locations_exclude = [],
        education_levels = [],
        education_fields = [],
        keywords = [],
        include_subsidiaries = false,
        is_extension_search = false,
        worked_previously_at_companies = false,
        school_groups = [],
        tied_to_role = false,
        allow_previous_job_titles = false,
        exclude_subsidiaries = false,
        exclude_years = 0,
        location_radius = 0,
        exact_job_title_match = false,
        exact_keywords_match = false,
        must_have_keywords = false,
        include_ai_suggetions = false,
      } = payload;
      state.active_search_role_id = active_search_role_id;
      state.search_name = search_name;
      state.job_titles = job_title;
      state.titles = titles;
      state.locations = locations;
      state.skills = skills;
      state.universities = universities;
      state.min_exp = min_exp;
      state.max_exp = max_exp;
      state.industries = industries;
      state.work_experiences = work_experiences;
      state.industry_leaders = industry_leaders;
      state.search_questions = search_questions;
      state.segments = segments;
      state.company = candidate_works && candidate_works.length ? candidate_works : company;
      state.exclude_company = exclude_company;
      state.agencies = agencies;
      state.agency_parents = agencyParent;
      state.agency_types = agencyType;
      state.processing_search_id = null;
      state.worked_previously_at_companies = worked_previously_at_companies;
      state.industry_type = companyGroups;
      state.school_groups = school_groups;
      state.keywords = keywords;
      state.education_levels = education_levels;
      state.education_fields = education_fields;
      state.allow_previous_job_titles = allow_previous_job_titles;

      state.exclude_locations =
        exclude_locations && exclude_locations.length ? exclude_locations : locations_exclude || [];
      // state.active_search_role_name = null;
      state.include_subsidiaries = include_subsidiaries;
      state.is_extension_search = is_extension_search;
      state.exclude_subsidiaries = exclude_subsidiaries;
      state.tied_to_role = tied_to_role;
      state.active_step = 0;
      state.ever_worked = false;
      state.search_question_set_id = null;
      state.ever_worked = false;
      state.searchingLoading = false;
      state.run_sinecure_search = true;
      state.run_doximity = undefined;
      state.exclude_years = exclude_years;
      state.location_radius = location_radius;
      state.exact_job_title_match = exact_job_title_match;
      state.exact_keywords_match = exact_keywords_match;
      state.must_have_keywords = must_have_keywords;
      state.include_ai_suggetions = include_ai_suggetions;
    },
    setPartialSearch: (state, action: PayloadAction<Partial<any>>) => {
      const payload = action.payload;
      return {
        ...state,
        ...payload,
      };
    },

    resetSearch: (state) => {
      state.active_search_role_id = null;
      state.search_name = "";
      state.job_titles = [];
      state.full_name = null;
      state.isNamedSearch = false;
      state.titles = [];
      state.locations = [];
      state.skills = [];
      state.universities = [];
      state.min_exp = 1;
      state.max_exp = 60;
      state.industries = [];
      state.work_experiences = [];
      state.industry_leaders = [];
      state.search_questions = [];
      state.segments = [];
      state.company = [];
      state.exclude_company = [];
      state.agencies = [];
      state.agency_parents = [];
      state.agency_types = [];
      state.processing_search_id = null;
      state.worked_previously_at_companies = false;
      state.include_subsidiaries = false;
      state.is_extension_search = false;
      state.industry_type = [];
      state.school_groups = [];
      state.exclude_locations = [];
      state.keywords = [];
      state.active_search_role_name = null;
      state.education_levels = [];
      state.education_fields = [];
      state.active_step = 0;
      state.ever_worked = false;
      state.search_question_set_id = null;
      state.ever_worked = false;
      state.searchingLoading = false;
      state.run_sinecure_search = true;
      state.run_doximity = undefined;
      state.tied_to_role = false;
      state.allow_previous_job_titles = false;
      state.exclude_subsidiaries = false;
      state.exclude_years = 0;
      state.location_radius = 0;
      state.exact_job_title_match = false;
      state.exact_keywords_match = false;
      state.must_have_keywords = false;
      state.include_ai_suggetions = false;
    },
    resetSearchConfig: (state) => {
      // state.search_name = "";
      state.job_titles = [];
      state.full_name = null;
      state.titles = [];
      state.locations = [];
      state.skills = [];
      state.universities = [];
      state.min_exp = 1;
      state.max_exp = 60;
      state.industries = [];
      state.work_experiences = [];
      state.industry_leaders = [];
      state.search_questions = [];
      state.segments = [];
      state.company = [];
      state.exclude_company = [];
      state.agencies = [];
      state.agency_parents = [];
      state.agency_types = [];
      state.worked_previously_at_companies = false;
      state.include_subsidiaries = false;
      state.ever_worked = false;
      state.is_extension_search = false;
      state.ever_worked = false;
      state.searchingLoading = false;
      state.industry_type = [];
      state.school_groups = [];
      state.exclude_locations = [];
      state.keywords = [];
      state.education_levels = [];
      state.education_fields = [];
      state.tied_to_role = false;
      state.allow_previous_job_titles = false;
      state.exclude_subsidiaries = false;
      state.exclude_years = 0;
      state.location_radius = 0;
      state.exact_job_title_match = false;
      state.exact_keywords_match = false;
      state.must_have_keywords = false;
      state.include_ai_suggetions = false;
    },
    setSelectedProject: (state, action: PayloadAction<any>) => {
      state.selectedProject = action.payload;
    },
    replaceSearchBy: (state, action: PayloadAction<any>) => {
      const {
        excludeCompany,
        excludeLocations,
        includeCompanies,
        includeLocations,
        jobTitle,
        minExp,
        maxExp,
        skills,
        keywords,
        industry_type,
        full_name,
      } = action.payload;

      if (jobTitle && jobTitle.length > 0) {
        state.job_titles = [...jobTitle];
      } else {
        state.job_titles = [];
      }
      if (full_name) {
        state.full_name = full_name;
      }
      if (excludeLocations && excludeLocations.length > 0) {
        state.exclude_locations = [...excludeLocations];
      } else {
        state.exclude_locations = [];
      }
      if (includeCompanies && includeCompanies.length > 0) {
        state.company = [...includeCompanies];
      } else {
        state.company = [];
      }
      if (industry_type && industry_type.length > 0) {
        state.industry_type = [...industry_type];
      } else {
        state.industry_type = [];
      }
      if (includeLocations && includeLocations.length > 0) {
        state.locations = [...includeLocations];
      } else {
        state.locations = [];
      }
      if (excludeCompany && excludeCompany.length > 0) {
        state.exclude_company = [...excludeCompany];
      } else {
        state.exclude_company = [];
      }
      state.min_exp = minExp;
      state.max_exp = maxExp;
      if (skills && skills.length > 0) {
        state.skills = [...skills];
      } else {
        state.skills = [];
      }
      if (keywords && keywords.length > 0) {
        state.keywords = [...keywords];
      } else {
        state.keywords = [];
      }
    },
    resetCancelling: (state) => {
      state.isCancelling = false;
    },
    resetSearchLoading: (state) => {
      state.searchingLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetSearchResultList.pending, (state, action) => {
      state.search_log_loading = 1;
    });
    builder.addCase(doGetSearchResultList.fulfilled, (state, action) => {
      state.search_log_loading = 2;
      state.search_log = action.payload;
    });
    builder.addCase(doCancelSearch.pending, (state) => {
      state.isCancelling = true;
    });
    builder.addCase(doCancelSearch.fulfilled, (state, action) => {
      state.isCancelling = false;
      state.processing_search_id = null;
    });
    builder.addCase(addIndustryTypeAsync.fulfilled, (state, action) => {
      const industry = action.payload;
      if (industry.length > 0) {
        state.industry_type = [...industry];
      }
    });
  },
});

export const {
  addJobTitle,
  removeJobTitle,
  removeAllJobTitle,
  addLocation,
  removeLocation,
  addSkill,
  addSkills,
  removeSkill,
  resetSkill,
  addFullName,
  addUniversity,
  removeUniversity,
  addIndustry,
  removeIndustry,
  addIndustryLeader,
  removeWorkExperience,
  addIndustrysegment,
  removeIndustryLeader,
  addAllIndustrysegment,
  addCandidateWorkCompany,
  removeCandidateWorkCompany,
  addExcludeCompany,
  removeExcludeCompany,
  resetExcludeCompany,
  removeMinMaxExp,
  addName,
  changeResetChat,
  changeIsFreelance,
  removeName,
  setRoleId,
  resetRoleId,
  setProcessingSearchId,
  removeProcessingSearchId,
  addMaxExp,
  addMinExp,
  resetSearch,
  resetSearchConfig,
  setModelCandidate,
  setAgencies,
  resetAgencies,
  setAgencyParent,
  setAgencyType,
  removeAgencies,
  resetAgencyType,
  removeAgencyParent,
  resetAgencyParent,
  removeAgencyType,
  addLocations,
  resetLocations,
  addSingleLocations,
  changeIsNamedSearch,
  addCandidateWorkCompanyList,
  resetCandidateWorkCompanyList,
  setWorkOnPreviousCompany,
  setIncludeSubsidiaries,
  setExtensionSearch,
  setMultipleAgencyType,
  addIndustryType,
  removeIndustryType,
  addExcludeLocation,
  addExcludeLocations,
  resetExcludeLocations,
  removeExcludeLocation,
  setRoleName,
  resetRoleName,
  setActiveStep,
  setSearchQuestionSetId,
  setEverWorked,
  setSearchLoading,
  setIsSinecure,
  setIsDoximity,
  setSearch,
  addStartYear,
  addEndYear,
  addKeyword,
  removeKeyword,
  resetKeyword,
  addSchoolGroup,
  removeSchoolGroup,
  setPartialSearch,
  addEducationFields,
  addEducationLevels,
  removeEducationFields,
  removeEducationLevels,
  setTieToRole,
  setMultipleAgency,
  addCandidateExcludeCompanyList,
  setTitleWithPreviousJob,
  setExcludeSubsidiaries,
  setExcludeYears,
  addSalesJobTitle,
  updateLocationRadius,
  setSearchStatus,
  clearAllSkills,
  clearAllCompanies,
  clearAllJobTitle,
  clearAllIndustry,
  clearFullName,
  clearAllExcludeCompanies,
  clearAllLocation,
  clearAllExcludeLocation,
  clearAllIndustryLeader,
  clearAllUniversities,
  clearAllFields,
  clearAllEducationLevel,
  setExactJobTitleMatch,
  resetExactJobTitleMatch,
  setExactkeywordsMatch,
  setMustHavekeywords,
  resetMustHavekeywords,
  resetExactkeywordsMatch,
  setIncludeAISuggetions,
  resetIncludeAISuggetions,
  setOnlyGreenHouseCandidate,
  resetOnlyGreenHouseCandidate,
  setOnlyLeverCandidate,
  resetOnlyLeverCandidate,
  setSelectedProject,
  clearSelectedProject,
  replaceSearchBy,
  setSelectedProjectFromSearch,
  removeSearchQuestions,
  addSearchQuestions,
  setSearchQuestions,
  clearSearchQuestions,
} = searchSlice.actions;
export default searchSlice.reducer;
